"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Tue Oct 16 2018
*/

var typescript_ioc_1 = require("@logio/typescript-ioc");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var index_1 = require("../../core/utils/index");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var WindowWarningFlag_1 = require("../../window/model/WindowWarningFlag");

var Window_1 = require("../model/Window");

var CoordinatorFlagsConverter_1 = require("./CoordinatorFlagsConverter");

var WindowConverter_1 = require("./WindowConverter");

var WindowDerivedDataConverter_1 = require("./WindowDerivedDataConverter");

var WindowSimulationConverter_1 = require("./WindowSimulationConverter");
/**
 * Default implementation of WindowConverter.
 *
 * @author JMt
 */


var WindowConverterImpl =
/*#__PURE__*/
function (_WindowConverter_1$Wi) {
  _inherits(WindowConverterImpl, _WindowConverter_1$Wi);

  function WindowConverterImpl(userInfoConverter, windowSimulationConverter, coordinatorFlagsConverter, windowDerivedDataConverter) {
    var _this;

    _classCallCheck(this, WindowConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    _this.windowSimulationConverter = windowSimulationConverter;
    _this.coordinatorFlagsConverter = coordinatorFlagsConverter;
    _this.windowDerivedDataConverter = windowDerivedDataConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Window_1.Window(Window_1.Window.schema.id.valueOf(conversions.documentToClassId(source)), Window_1.Window.schema.externalId.valueOfField(source), Window_1.Window.schema.workflowCaseId.valueOf(conversions.toClassReferenceId(source.workflowCaseId)), Window_1.Window.schema.workflowState.valueOfField(source), Window_1.Window.schema.workflowModified.valueOfField(source), Window_1.Window.schema.workflowNote.valueOfField(source), Window_1.Window.schema.name.valueOfField(source), Window_1.Window.schema.dateFrom.valueOfField(source), Window_1.Window.schema.dateTo.valueOfField(source), !index_1.Utils.isValueMissing(source.ecommerce) ? Window_1.Window.schema.ecommerce.valueOfField(source) : false, conversions.asObjectOpt(source, 'forecastCoordinatorFlag', this.deserializeCoordinator(conversions)), Window_1.Window.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), Window_1.Window.schema.portfolio.valueOf(conversions.toClassReferenceId(source.portfolio)), Window_1.Window.schema.priceValidityStart.valueOfField(source), Window_1.Window.schema.priceValidityEnd.valueOfField(source), Window_1.Window.schema.leafletDescription.valueOfField(source), Window_1.Window.schema.leafletPageNo.valueOfField(source), !index_1.Utils.isValueMissing(source.marketingComment) ? Window_1.Window.schema.marketingComment.valueOfField(source) : null, Window_1.Window.schema.windowTypeId.valueOf(conversions.toClassReferenceId(source.windowTypeId)), Window_1.Window.schema.themeId.valueOf(source.themeId ? conversions.toClassReferenceId(source.themeId) : null), Window_1.Window.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), Window_1.Window.schema.modified.valueOfField(source), this.userInfoConverter.toObject(source.modifiedBy, conversions), this.userInfoConverter.toObject(source.ownedBy, conversions), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), conversions.asObjectOpt(source, 'simulation', this.deserializeSimulation(conversions)), Window_1.Window.schema.dummy.valueOfField(source), Window_1.Window.schema.dummyOriginId.valueOf(conversions.toClassReferenceId(source.dummyOriginId)), source.classification, this.windowDerivedDataConverter.toObject(source.derivedData, conversions), Window_1.Window.schema.processed.valueOfField(source), conversions.asFlagSet(source.warningFlags, WindowWarningFlag_1.WindowWarningFlag), Window_1.Window.schema.snapshotOriginId.valueOf(conversions.toClassReferenceId(source.snapshotOriginId)), Window_1.Window.schema.source.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        workflowCaseId: conversions.toDocumentReferenceId(source.workflowCaseId),
        workflowState: source.workflowState,
        workflowModified: source.workflowModified !== null ? conversions.fromDate(source.workflowModified) : null,
        workflowNote: source.workflowNote,
        name: source.name,
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        ecommerce: source.ecommerce,
        forecastCoordinatorFlag: conversions.asObjectOpt(source, 'forecastCoordinatorFlag', this.serializeCoordinator(conversions)),
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        portfolio: conversions.toDocumentReferenceId(source.portfolio),
        priceValidityStart: source.priceValidityStart !== null ? conversions.fromDate(source.priceValidityStart) : null,
        priceValidityEnd: source.priceValidityEnd !== null ? conversions.fromDate(source.priceValidityEnd) : null,
        leafletDescription: source.leafletDescription,
        leafletPageNo: source.leafletPageNo,
        marketingComment: source.marketingComment,
        windowTypeId: conversions.toDocumentReferenceId(source.windowTypeId),
        themeId: source.themeId !== null ? conversions.toDocumentReferenceId(source.themeId) : null,
        created: conversions.fromDate(source.created),
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions),
        modified: conversions.fromDate(source.modified),
        modifiedBy: this.userInfoConverter.toDocument(source.modifiedBy, conversions),
        ownedBy: this.userInfoConverter.toDocument(source.ownedBy, conversions),
        stateFlags: source.stateFlags.serialize(),
        simulation: conversions.asObjectOpt(source, 'simulation', this.serializeSimulation(conversions)),
        dummy: source.dummy,
        dummyOriginId: source.dummyOriginId !== null ? conversions.toDocumentReferenceId(source.dummyOriginId) : null,
        classification: source.classification,
        derivedData: this.windowDerivedDataConverter.toDocument(source.derivedData, conversions),
        processed: source.processed,
        warningFlags: source.warningFlags.serialize(),
        snapshotOriginId: index_1.Utils.isValueMissing(source.snapshotOriginId) ? null : conversions.toDocumentReferenceId(source.snapshotOriginId),
        source: source.source
      });
      return result;
    }
  }, {
    key: "deserializeSimulation",
    value: function deserializeSimulation(conversions) {
      var _this2 = this;

      return function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.windowSimulationConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeSimulation",
    value: function serializeSimulation(conversions) {
      var _this3 = this;

      return function (object) {
        return index_1.Utils.isValueMissing(object) ? null : _this3.windowSimulationConverter.toDocument(object, conversions);
      };
    }
  }, {
    key: "deserializeCoordinator",
    value: function deserializeCoordinator(conversions) {
      var _this4 = this;

      return function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this4.coordinatorFlagsConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeCoordinator",
    value: function serializeCoordinator(conversions) {
      var _this5 = this;

      return function (object) {
        return index_1.Utils.isValueMissing(object) ? null : _this5.coordinatorFlagsConverter.toDocument(object, conversions);
      };
    }
  }]);

  return WindowConverterImpl;
}(WindowConverter_1.WindowConverter);

WindowConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter, WindowSimulationConverter_1.WindowSimulationConverter, CoordinatorFlagsConverter_1.CoordinatorFlagsConverter, WindowDerivedDataConverter_1.WindowDerivedDataConverter])], WindowConverterImpl);
exports.WindowConverterImpl = WindowConverterImpl;